import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import AttendeeTable from '@activities/components/tables/activity-session-attendee-table/activity-session-attendee-table.vue';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';

@Component({
  name: 'bpc-attendee-table-input',
  components: {
    'bpc-activity-session-attendee-table': AttendeeTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class AttendeeTableInput extends mixins(AbstractField) {
  declare $refs: AbstractField['$refs'] & {
    attendeeTable: InstanceType<typeof AttendeeTable> & {
      getEntities(): void;
    };
  };
  @Prop(Array) readonly value: any[];
  @Prop(Object) readonly externalFormModel: object;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' })
  readonly formConfigName: string;
  @Prop({ type: String, default: 'edit' })
  readonly editFormConfigName: string;
  @Prop({
    type: Array,
    default: () => {
      return ['default'];
    },
  })
  readonly selectConfigName: string[];
  @Prop({ type: Boolean, default: true }) readonly showTableHeader: boolean;
  @Prop({ type: Boolean, default: true }) readonly withSearch: boolean;
  @Prop({ type: Boolean, default: true }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showPagination: boolean;
  @Prop({ type: Boolean, default: true }) readonly showTabFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrderBy: boolean;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'filtersLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  public entity: ActivitySessionAttendee = null;
  public entityName = 'activity-session-attendee';
  public pluralEntityName = 'activity-session-attendees';
  public permissionEntityNameToUse = 'activity_session_attendees';

  getEntities() {
    return this.$refs.attendeeTable?.getEntities();
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  get mode(): string {
    return 'api';
  }
}
